// Modelo padrão de Termo de Uso de Imagem — Casa Alta 2026.
// Trocar por versão jurídica final quando disponível (mantenha a `VERSION`).
export const TERMO_VERSION = "v1";

export const TERMO_TITLE = "Termo de Autorização de Uso de Imagem e Voz";

export const TERMO_INTRO =
  "Casa Alta 2026 · Alta Agency · Shambala House, São Paulo — 04 a 06 de agosto de 2026";

export const TERMO_CLAUSES = [
  {
    n: "01",
    title: "Autorização",
    body:
      "Autorizo a Alta Agency e seus parceiros a captarem, editarem e utilizarem imagens fotográficas, gravações de vídeo e/ou de voz nas quais minha figura ou voz apareça, produzidas durante o evento Casa Alta 2026, realizado entre 04 e 06 de agosto de 2026, na Shambala House, em São Paulo/SP.",
  },
  {
    n: "02",
    title: "Finalidade",
    body:
      "As imagens e gravações poderão ser utilizadas para fins de divulgação institucional, marketing, publicidade, comunicação interna e externa da Alta Agency e de seus patrocinadores, em quaisquer mídias e formatos, incluindo internet, redes sociais, materiais impressos, mídia digital, TV, cinema e eventos.",
  },
  {
    n: "03",
    title: "Território e prazo",
    body:
      "A autorização é concedida para uso em território nacional e internacional, por prazo indeterminado.",
  },
  {
    n: "04",
    title: "Gratuidade",
    body:
      "A presente autorização é concedida em caráter gratuito e irrevogável, entendendo-se por contrapartida a hospedagem, alimentação, entregáveis de conteúdo e demais benefícios oferecidos pela Alta Agency durante e após o evento.",
  },
  {
    n: "05",
    title: "Ressalvas",
    body:
      "Comprometo-me a não utilizar as imagens de forma que denigra ou prejudique a imagem da Alta Agency, de outros participantes ou de patrocinadores. A Alta Agency, por sua vez, se compromete a utilizar o material apenas de forma compatível com o presente termo e com a boa-fé.",
  },
  {
    n: "06",
    title: "LGPD",
    body:
      "Estou ciente de que meus dados pessoais serão tratados conforme a Lei Geral de Proteção de Dados (Lei 13.709/2018), com a finalidade de organizar o evento e produzir/divulgar o conteúdo aqui descrito.",
  },
];

export const TERMO_SIGN_NOTE =
  "Ao digitar meu nome completo abaixo e marcar o campo de aceite, declaro que li, entendi e concordo integralmente com todas as cláusulas acima. Esta assinatura digital equivale, para todos os efeitos, à assinatura manuscrita, nos termos da MP 2.200-2/2001 e da legislação brasileira em vigor.";
